/**
 * Data field options: descriptions and category names (dfo.*). EN = source.
 * Option NAMES come from src/data/guides/settingsNames.ts (strings of the watch).
 */
const datafields = {
    "dfo": {
        "options": {
            "HR": "Current heart rate from the optical sensor.",
            "HRC": "Heart rate that keeps updating every second, also in low-power mode. MIP displays only.",
            "Ox": "Blood oxygen saturation (SpO2) from the pulse oximeter. Only on watches with a pulse oximeter.",
            "BB": "Body Battery from 0 to 100: Garmin’s estimate of your energy reserve.",
            "Str": "Current stress level from 0 to 100, based on heart rate variability.",
            "RR": "Current breathing rate in breaths per minute.",
            "TTR": "Recovery time in hours until you are ready for the next hard workout.",
            "slsc": "Sleep score of last night (0–100) as calculated by Garmin.",
            "cgmv": "Current value of your continuous glucose monitor. Needs the app “CGM Connect Widget” on the watch. Shows (?) if no new value arrived for 6 minutes.",
            "AVRHR": "Average resting heart rate of the last 7 days.",
            "VO2MC": "VO2 max for cycling from your Garmin profile.",
            "VO2MR": "VO2 max for running from your Garmin profile.",
            "cTstT": "Garmin Training Status, for example Productive, Maintaining or Recovery.",
            "AMD": "Intensity minutes today.",
            "AMW": "Intensity minutes this week, compared with your weekly goal.",
            "WCP": "Wheelchair pushes today. Only with wheelchair mode switched on.",
            "WCD": "Wheelchair distance today. Only with wheelchair mode switched on.",
            "S": "Steps today, with progress towards your step goal.",
            "STSG": "Steps left until you reach your daily step goal.",
            "Di": "Distance covered today, in the unit set on the watch.",
            "FC": "Floors climbed today, with progress towards your floor goal. Needs a barometer.",
            "MC": "Ascent today in meters or feet. Needs a barometer.",
            "C": "Total calories today, including the resting calories.",
            "ACTC": "Active calories today, without the resting calories.",
            "be": "Fun value: your active calories today converted into beers (about 250 kcal per 0.5 l).",
            "we": "Fun value: your active calories today converted into glasses of wine (about 150 kcal per 0.2 l).",
            "WEIG": "Your weight from the Garmin user profile, in kg or lb.",
            "AWRD": "Running distance of this week’s recorded activities.",
            "A7RD": "Running distance of the recorded activities of the last 7 days.",
            "AMRD": "Running distance of this month’s recorded activities.",
            "AWCD": "Cycling distance of this week’s recorded activities.",
            "A7CD": "Cycling distance of the recorded activities of the last 7 days.",
            "AMCD": "Cycling distance of this month’s recorded activities.",
            "AWSD": "Swimming distance of this week’s recorded activities.",
            "A7SD": "Swimming distance of the recorded activities of the last 7 days.",
            "AMSD": "Swimming distance of this month’s recorded activities.",
            "AWHD": "Hiking, walking and mountaineering distance of this week.",
            "A7HD": "Hiking, walking and mountaineering distance of the last 7 days.",
            "AMHD": "Hiking, walking and mountaineering distance of this month.",
            "A7FT": "Strength training time of the last 7 days.",
            "AWRT": "Running time of this week’s recorded activities.",
            "A7RT": "Running time of the last 7 days.",
            "AMRT": "Running time of this month.",
            "AWCT": "Cycling time of this week.",
            "A7CT": "Cycling time of the last 7 days.",
            "AMCT": "Cycling time of this month.",
            "AWST": "Swimming time of this week.",
            "A7ST": "Swimming time of the last 7 days.",
            "AMST": "Swimming time of this month.",
            "AWFT": "Strength training time of this week.",
            "AMFT": "Strength training time of this month.",
            "D": "Date in your own format, set with [link=/guides/date-format]Date 1 format[/link] further down in the settings.",
            "D2": "A second date in its own format, set with Date 2 format.",
            "D12": "Date 1 and Date 2 together; Date 2 takes the place of the icon.",
            "tts": "Countdown to your next sleep or wake-up time from the Garmin user profile, whichever comes first.",
            "d2do": "Days until (or since) a date you set further down in the settings. On the last day it switches to hours and minutes.",
            "TZ2": "Time in a second time zone. Set the offset in minutes further down. [link=/guides/timezones]Time zones[/link]",
            "TZ3": "Time in a third time zone, set like time zone 2.",
            "net": "Start time of your next calendar event, synced from your phone.",
            "sn": "Notification icon with the number of unread phone notifications.",
            "B": "Battery level in percent.",
            "BiDT": "Remaining battery life in days, if the watch provides it. Otherwise percent.",
            "STT": "Temperature of the watch’s internal sensor. Body heat raises it, so it is not the air temperature.",
            "So": "Current solar intensity in percent. Only on solar watches.",
            "SoC": "Solar intensity that keeps updating, also in low-power mode. MIP displays only.",
            "HS": "Altitude above sea level from the barometric altimeter.",
            "Pr": "Air pressure from the barometer history of the watch.",
            "APr": "Current ambient air pressure measured by the barometer.",
            "CW": "Current temperature from your weather provider. [link=/guides/weather]Weather setup[/link]",
            "FLT": "Feels-like temperature, which includes wind and humidity.",
            "MMT": "Lowest and highest temperature of today.",
            "CW2": "Wind speed with an arrow for the wind direction. The arrow can point to where the wind comes from (Inverse Wind Icon setting).",
            "WH": "Relative humidity in percent.",
            "WPC": "Chance of precipitation in percent.",
            "UV": "UV index. Garmin weather does not provide it; with OpenWeatherMap, newer keys need the free “One Call by Call” plan.",
            "AQI2": "Air quality index from the app Atmos Air Quality, which must be installed on the watch.",
            "DP": "Dew point, calculated from temperature and humidity.",
            "WDL": "Name of the weather location. With Garmin weather this is the nearest station. Shows GPS? without a stored position.",
            "WDT": "Time of the last weather update.",
            "WDD": "Short weather description such as “light rain” (OpenWeatherMap). Garmin weather has none.",
            "NGH": "Time of the next golden hour, when the low sun gives warm light.",
            "NSE": "Time of the next sunrise or sunset.",
            "NBH": "Time of the next blue hour, shortly before sunrise and after sunset.",
            "NDD": "Time of the next civil dawn or dusk (sun 6° below the horizon).",
            "NNDD": "Time of the next nautical dawn or dusk (sun 12° below the horizon).",
            "TGH": "Countdown to the next golden hour.",
            "TSE": "Countdown to the next sunrise or sunset.",
            "TBH": "Countdown to the next blue hour.",
            "TDD": "Countdown to the next civil dawn or dusk.",
            "TNDD": "Countdown to the next nautical dawn or dusk.",
            "SR": "Today’s sunrise, with a bar showing how far the day has progressed. Needs a stored position.",
            "SS": "Today’s sunset, with a bar showing how far the day has progressed. Needs a stored position.",
            "NADD": "Time of the next astronomical dawn or dusk (sun 18° below the horizon). In between, the sky is fully dark.",
            "TADD": "Countdown to the next astronomical dawn or dusk.",
            "MR": "Today’s moonrise.",
            "MS": "Today’s moonset.",
            "NMR": "Time of the next moonrise or moonset.",
            "MP": "Moon phase icon with the illuminated part in percent.",
            "MD": "Moon age: days since the last new moon.",
            "NTT": "Time of the next tide, high or low, with an icon for which one. Needs a Stormglass key. [link=/guides/tides]Set up tides[/link]",
            "NTL": "Time of the next low tide. Needs a Stormglass key.",
            "NTH": "Time of the next high tide. Needs a Stormglass key.",
            "CHH": "Heart rate history as a small chart.",
            "CHP": "Air pressure history as a small chart.",
            "CHE": "Elevation history as a small chart.",
            "CHT": "Sensor temperature history as a small chart.",
            "CHS": "Stress history as a small chart.",
            "N": "Leaves the field empty.",
            "ct": "A text of your own, entered further down in the settings.",
            "MGRS": "Your stored position as an MGRS coordinate (military grid reference system)."
        },
        "cats": {
            "health": "Health & Body",
            "activity": "Daily Activity",
            "activityDistance": "Activity History (Distance)",
            "activityTime": "Activity History (Time)",
            "dateTime": "Date & Time",
            "battery": "Battery & Sensors",
            "altitude": "Altitude & Pressure",
            "weather": "Weather",
            "sun": "Sun & Daylight",
            "moon": "Moon",
            "tides": "Tides",
            "charts": "Charts",
            "other": "Other"
        },
        "catDesc": {
            "activityDistance": "Sums of the activities recorded on this watch. On newer watches, Garmin can also provide the weekly running, cycling and swimming distance; then activities from other devices synced via Garmin Connect count too.",
            "activityTime": "Sums of the activities recorded on this watch."
        }
    }
};
export default datafields;
